import styled from 'styled-components';

import Media from '../../../assets/styles/media';

export const PageContent = styled.div`
  width: 100%;

  /* PageContent is a flex item beside LeftSpacer (240px), so it must shrink to the space that
     leaves. A flex item defaults to min-width:auto, which floors it at its content's min-content
     width - and on /app/maintenanceSchedule the 18-column schedule table raises that floor above
     the available width, so the shrink cannot happen and PageContent stays at its full 100%. It
     then sits AFTER the 240px spacer, putting the page exactly 240px wider than the viewport at
     every screen size and dragging the right-aligned header hero out of view with it (PORTAL-32).
     min-width:0 removes the floor. Pages whose content already fits are unaffected - they shrink
     correctly today and continue to. */
  min-width: 0;
`;

export const PageCtn = styled.div`
  display: flex;
  padding-bottom: 80px;

  ${Media.Below.mobileLarge`
    flex-direction: column;
  `}
`;

export const LeftSpacer = styled.div`
  min-width: 240px;

  ${Media.Below.desktop`
    min-width: 70px;
    width: 70px;
  `}

  ${Media.Below.mobileLarge`
    min-width: 0px;
    width: 0px;
    height: 110px;
  `}
`;
